import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../shared/auth.guard';
import { CpMemberProfileComponent } from './components/cp-member-profile/cp-member-profile.component';
import { CpMemberComponent } from './components/cp-member/cp-member.component';
import { CpMemberEnrollmentComponent } from './components/cp-member-enrollment/cp-member-enrollment.component';
import { EndorsementComponent } from './components/endorsement/endorsement.component';
import { TrackClaimsComponent } from '../corporate-portal/components/track-claims/track-claims.component';
import { IntimateClaimComponent } from '../corporate-portal/components/intimate-claim/intimate-claim.component';
import { PolicyCoverageComponent } from '../corporate-portal/components/policy-coverage/policy-coverage.component';
import { ECardsComponent } from '../corporate-portal/components/e-cards/e-cards.component';
import { DownloadFormsComponent } from '../corporate-portal/components/download-forms/download-forms.component';
import { FaqComponent } from '../corporate-portal/components/faq/faq.component';
import { ContactUsComponent } from '../corporate-portal/components/contact-us/contact-us.component';
import { DashboardComponent } from '../corporate-portal/components/dashboard/dashboard.component';
import { ReportComponent } from '../corporate-portal/components/report/report.component';
import { NotificationsComponent } from '../corporate-portal/components/notifications/notifications.component';
import { FinalDeclarationComponent } from '../corporate-portal/components/final-declaration/final-declaration.component';
import { ActiveSessionsComponent } from '../corporate-portal/components/active-sessions/active-sessions.component';
import { GpaComponent } from '../corporate-portal/components/gpa/gpa.component';
import { PaciComponent } from '../corporate-portal/components/paci/paci.component';
import { CpAddNomineeFormComponent } from './components/cp-nominee-enroll/add-nominee-form/add-nominee-form.component';
import { CpMemberHomeComponent } from './cp-member-home/cp-member-home.component';
import { ClaimDetailsComponent } from '../corporate-portal/components/track-claims/claim-details/claim-details.component';
import { DocumentUploadComponent } from '../corporate-portal/components/upload-documents/document-upload/document-upload.component';
import { CreateEmployeeEndorsementComponent } from './components/endorsement/create-employee-endorsement/create-employee-endorsement.component';
import { CpNomineeEnrollComponent } from './components/cp-nominee-enroll/cp-nominee-enroll.component';
import { ManageProfileComponent } from '../corporate-portal/components/manage-profile/manage-profile.component';
import { StartClaimComponent } from '../corporate-portal/components/start-claim/start-claim.component';
import { NetworkHospitalsComponent } from '../corporate-portal/components/network-hospitals/network-hospitals.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    data: { roles: ['CPMember', 'CPHR'] },
    children: [
      { path: 'home', component: CpMemberHomeComponent },
      { path: 'profile', redirectTo: 'home', pathMatch: 'full' },
      { path: 'claims', component: TrackClaimsComponent },
      { path: 'claim-details/:id', component: ClaimDetailsComponent },
      { path: 'upload-documents/:id', component: DocumentUploadComponent },
      { path: 'start-claim', component: StartClaimComponent },
      { path: 'manage-profile', component: ManageProfileComponent },
      { path: 'intimate-claim', component: IntimateClaimComponent },
      { path: 'policy-coverage', component: PolicyCoverageComponent },
      { path: 'network-hospitals', component: NetworkHospitalsComponent },
      { path: 'add-family-member', component: CreateEmployeeEndorsementComponent },
      { path: 'add-nominee', component: CpAddNomineeFormComponent },
      { path: 'e-cards', component: ECardsComponent },
      { path: 'download-forms', component: DownloadFormsComponent },
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'faq', component: FaqComponent },
      { path: 'contact', component: ContactUsComponent },
      { path: 'enrollment', component: CpMemberEnrollmentComponent },
      { path: 'endorsement', component: EndorsementComponent },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'report', component: ReportComponent },
      { path: 'notification', component: NotificationsComponent },
      { path: 'final-decalartion', component: FinalDeclarationComponent },
      { path: 'attendance', component: ActiveSessionsComponent },
      { path: 'gpa', component: GpaComponent},
      { path:'gpm', component:GpaComponent },
      { path: 'paci', component: PaciComponent},
      { path: 'nominee-enroll', component: CpNomineeEnrollComponent}
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CpMemberRoutingModule {
  constructor() {}
}
